(ns common.schema.entities.related-entities
  (:require [common.util :as cu]))

(defn particular-value [value entity-lookup entity-type]
  (->> value
       (keep entity-lookup)
       (remove :common/disabled?)
       (cu/filter-by :entity/type entity-type)
       (map :db/id)))

(defn calculate-value [{:keys [entity-data entity-lookup]} entity-type]
  (particular-value
   (:common/related-entities entity-data)
   entity-lookup
   entity-type))

(defn related-field-schema [labels entity-type]
  {
   :field/default-authorization {:access/read  :role/user
                                 :access/write :role/user}
   :field/translations          labels
   :field/data-type             :data.type/ref-multi
   :value-type                  :entity
   :field/entity-types          [entity-type]
   :field/aggregate-attribute   :common/related-entities
   :field/calculated-field      (fn [args]
                                  (calculate-value args entity-type))
   :field/particular-value      (fn [value entity-lookup]
                                  (particular-value value entity-lookup entity-type))
   :create-on-fly?              (contains? #{:entity.type/company :entity.type/person} entity-type)
   :field/default-visibility    {:editor :editor.type/related-entities
                                 :grid   :editor.type/related-entities
                                 :filter :filter.type/select
                                 :field-visibility :in-use}})

(def related-entities
  [[:common/related-entities-oppo (related-field-schema {:en "Associated deals"} :entity.type/oppo)]
   [:common/related-entities-person (related-field-schema {:en "Associated people"} :entity.type/person)]
   [:common/related-entities-company (related-field-schema {:en "Associated companies"} :entity.type/company)]
   [:common/related-entities-real-estate (related-field-schema {:en "Associated real estate"} :entity.type/real-estate)]
   [:common/related-entities-fof-asset (related-field-schema {:en "Associated funds"} :entity.type/fof-asset)]
   [:common/related-entities-other-asset (related-field-schema {:en "Associated generic assets"} :entity.type/other-asset)]
   [:common/related-entities-investor (related-field-schema {:en "Associated investors"} :entity.type/investor)]
   [:common/related-entities-fund (related-field-schema {:en "Associated funds (our)"} :entity.type/fund)]
   [:common/related-entities-fundraising-opportunities
    (related-field-schema {:en "Associated fundraising opportunities"} :entity.type/fundraising-opportunity)]
   [:common/related-entities-sales-opportunities
    (related-field-schema {:en "Associated sales opportunities"} :entity.type/sales-opportunity)]
   [:common/related-entities-exit-opportunities
    (related-field-schema {:en "Associated exit opportunities"} :entity.type/exit-opportunity)]
   [:common/related-entities-holdings (related-field-schema {:en "Associated holdings"} :entity.type/holding)]
   [:common/related-entities-sale-agreements (related-field-schema {:en "Associated agreements"} :entity.type/sale-agreement)]
   [:common/related-entities-fund-commitment (related-field-schema {:en "Associated commitments"} :entity.type/fund-commitment)]])
